import { PLAN_KEY } from '../../constants'
import { getValueReduxUtil } from '../../../../redux'

function getParentIdPlanUtil (plan) {
  return getValueReduxUtil(
    plan, PLAN_KEY.PARENT_ID
  )
}

export default getParentIdPlanUtil
